<div id="DashboardAndTabs" #dashboard style="height: 59.5%;">
  <ul class="nav nav-tabs" style="border: none;;">
    <li class="nav-item">
      <a class="nav-link active" data-bs-toggle="tab" data-bs-target="#screenshots"><em class="fa fa-camera"
          style="color: #6eb2ff;"></em>{{" Screenshots" | translate}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-bs-toggle="tab" data-bs-target="#Screenrecord"><em class="fa fa-video-camera"
          style="color: #e04415;"></em>{{" Screen Record" | translate}}</a>
    </li>


  </ul>

  <div class="tab-content" style="max-height: 90%; overflow-y: auto; overflow-x: hidden;">
    <div id="screenshots" class="tab-pane fade show active">
      <app-screenshots [control]="control" [device]="device"></app-screenshots>
    </div>
    <div id="Screenrecord" class="tab-pane fade">
      <app-screenrecord [device]="device"></app-screenrecord>
    </div>
  </div>
</div>

<!-- <div class="tab-content" style="max-height: 90%; overflow-y: auto; overflow-x: hidden;">

<div id="screenshots" class="tab-pane fade">
    <app-screenshots [control]="control" [device]="device"></app-screenshots>
  </div>
  <div id="Screenrecord" class="tab-pane fade">
     <app-screenrecord   [device]="device"></app-screenrecord>
  </div> 
</div> -->